(function () {
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  var BEACON_URL = 'https://hub.sarron.in/api/beacon';

  var DOMAIN_TYPOS = {
    'gamil.com':'gmail.com','gmial.com':'gmail.com','gmai.com':'gmail.com',
    'gnail.com':'gmail.com','gmaill.com':'gmail.com','gmil.com':'gmail.com',
    'gmal.com':'gmail.com','gmali.com':'gmail.com','gmail.co':'gmail.com',
    'yaho.com':'yahoo.com','yahooo.com':'yahoo.com','yhaoo.com':'yahoo.com',
    'yahoo.co':'yahoo.com',
    'hotmial.com':'hotmail.com','hotmal.com':'hotmail.com','hotmil.com':'hotmail.com',
    'hotmail.co':'hotmail.com',
    'outlok.com':'outlook.com','outloo.com':'outlook.com','outlookcom':'outlook.com',
    'outlook.co':'outlook.com',
    'iclod.com':'icloud.com','icloud.co':'icloud.com',
    'protonmal.com':'protonmail.com','protonmail.co':'protonmail.com',
    'rediffmal.com':'rediffmail.com','rediffmail.co':'rediffmail.com'
  };

  function checkEmailTypo(email) {
    var parts = email.toLowerCase().split('@');
    if (parts.length !== 2) return null;
    var domain = parts[1];
    return DOMAIN_TYPOS[domain] ? parts[0] + '@' + DOMAIN_TYPOS[domain] : null;
  }

  function sendBeaconEvent(payload) {
    var body = JSON.stringify({ events: [payload] });
    try {
      var sent = navigator.sendBeacon && navigator.sendBeacon(BEACON_URL, new Blob([body], { type: 'text/plain' }));
      if (!sent) {
        fetch(BEACON_URL, { method: 'POST', body: body, keepalive: true, credentials: 'omit' });
      }
    } catch (e) {}
  }

  function track(event) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: event });
    sendBeaconEvent({ event: event, page_url: location.pathname });
  }

  var forms = document.querySelectorAll('form[id^="newsletter-form-"]');
  if (!forms.length) return;

  forms.forEach(function (form) {
    if (form.dataset.nlFooterInit) return;
    form.dataset.nlFooterInit = '1';

    var emailInput = form.querySelector('input[type="email"]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var hpField = form.querySelector('input[name="company_name"]');
    var msgContainer = form.parentElement.querySelector('.footer-nl-msg');

    if (emailInput) emailInput.setAttribute('inputmode', 'email');

    var pendingSuggestion = null;

    function showMsg(text, isError) {
      if (!msgContainer) return;
      msgContainer.textContent = text;
      msgContainer.style.display = 'block';
      msgContainer.style.color = isError ? '#dc2626' : '#555';
      msgContainer.style.fontSize = '13px';
      msgContainer.style.marginTop = '8px';
    }

    function showSuggestion(suggested) {
      if (!msgContainer) return;
      msgContainer.innerHTML = '';
      msgContainer.appendChild(document.createTextNode('Did you mean '));
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = suggested;
      btn.style.cssText = 'background:none;border:none;color:#7f1734;text-decoration:underline;cursor:pointer;font-size:13px;padding:0;font-family:inherit';
      msgContainer.appendChild(btn);
      msgContainer.appendChild(document.createTextNode('?'));
      msgContainer.style.display = 'block';
      msgContainer.style.fontSize = '13px';
      msgContainer.style.marginTop = '8px';
      msgContainer.style.color = '#555';
      btn.addEventListener('click', function () {
        emailInput.value = suggested;
        msgContainer.style.display = 'none';
        pendingSuggestion = null;
      });
    }

    function clearMsg() {
      if (msgContainer) msgContainer.style.display = 'none';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearMsg();

      if (hpField && hpField.value) {
        track('nl_footer_bot');
        showMsg('Thank you for subscribing!', false);
        return;
      }

      var email = emailInput ? emailInput.value.trim() : '';

      if (!email || !EMAIL_RE.test(email)) {
        showMsg('Please enter a valid email address.', true);
        if (emailInput) emailInput.focus();
        return;
      }

      var suggestion = checkEmailTypo(email);
      if (suggestion && suggestion !== pendingSuggestion) {
        pendingSuggestion = suggestion;
        showSuggestion(suggestion);
        return;
      }

      if (submitBtn) submitBtn.disabled = true;
      track('nl_footer_submit');

      var formData = new FormData(form);
      formData.delete('company_name');

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          return response.text().then(function (html) {
            return { ok: response.ok, html: html };
          });
        })
        .then(function (result) {
          if (result.ok) {
            if (result.html.length < 10 || result.html.indexOf('Verifying') !== -1 || result.html.indexOf('challenge') !== -1) {
              throw new Error('blocked');
            }
            track('nl_footer_success');
            showMsg('Thank you for subscribing!', false);
            if (emailInput) emailInput.value = '';
            return;
          }

          var isAlreadyTaken =
            result.html.indexOf('has already been taken') !== -1 ||
            result.html.indexOf('email has already') !== -1;

          if (isAlreadyTaken) {
            track('nl_footer_already_subscribed');
            showMsg('You are already subscribed!', false);
            return;
          }

          throw new Error('submit failed');
        })
        .catch(function () {
          track('nl_footer_error');
          showMsg('Something went wrong. Please try again.', true);
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });
})();
